import config from '@/modules/form/config';

export default {
  methods: {
    prepareFieldConfig(fieldConfig, scopeId = 'random-scope', scope = '') {
      const { params, validation } = this.getParamsAndValidationFromFieldConfig(fieldConfig);
      return {
        component: fieldConfig.component,
        field: fieldConfig.field,
        key: `${fieldConfig.field}@${scopeId}`,
        label: this.getLabel(fieldConfig, scope),
        name: fieldConfig.field,
        params,
        validation,
        showInBasicEditor: fieldConfig.showInBasicEditor,
      };
    },
    getLabel(fieldConfig, scope = '') {
      const { label } = fieldConfig;
      if (!label) {
        return '';
      }

      const translationCandidates = [
        `message.form.fields.${scope}.${this.normalizeLocaleString(label)}`,
        `message.form.fields.${this.normalizeLocaleString(label)}`,
      ];
      const translation = translationCandidates.find(candidate => this.$te(candidate));
      if (translation) {
        return this.$t(translation);
      }

      console.log('Missing translation for field label:', label);
      return label;
    },
    normalizeLocaleString(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    getParamsAndValidationFromFieldConfig(fieldsConfig) {
      const fieldParams = fieldsConfig.params || {};
      const params = {};
      const validation = {};

      const paramsPropagatedFromFieldConfig = [
        'triggerPopulation',
        'usePopulateFieldsCmsApiService',
        'ignorePopulation',
        'requestPopulationFrom',
        'bcubeAssistantComponent',
      ];

      Object.entries(fieldsConfig).forEach(([key, value]) => {
        if (paramsPropagatedFromFieldConfig.includes(key)) {
          Object.assign(params, { [key]: value });
        }
      });

      Object.entries(fieldParams).forEach(([key, value]) => {
        (config.validationRules.includes(key) ? validation : params)[key] = value;
      });

      return {
        params: this.prepareParams(params),
        validation: this.prepareValidation(validation),
      };
    },
    prepareParams(params) {
      if (this.disabled) {
        params.disabled = this.disabled;
      }
      return params;
    },
    prepareValidation(validation) {
      // Regex special case https://baianat.github.io/vee-validate/guide/rules.html#regex
      if (validation.regex && validation.regex.pattern) {
        validation.regex = this.getRegExpObjectFromString(validation.regex.pattern);
      }
      return validation;
    },
    getRegExpObjectFromString(str) {
      if (str instanceof RegExp) {
        return str;
      }
      if (str.startsWith('/') && str.endsWith('/')) {
        return new RegExp(str.slice(1, -1));
      }
      return new RegExp(str);
    },
  },
};
